<template>
  <div>
    <Builder
      :chapter="dataObj.imprint.title"
      :dataObj="dataObj.imprint.data"
      :pano="dataObj.imprint.pano"
    />
    <div class="flags">
      <div>
        <img src="/assets/img/imprint/EU-Flag-vector-big.png" />
        <img src="/assets/img/imprint/LOGO-ERC.png" />
      </div>
      <div>
        <img src="/assets/img/imprint/Hidden-Galleries-Greyscale-01.png" />
        <img src="/assets/img/imprint/UCC-Logo-RGB-detailed_NEW.png" />
        <img src="/assets/img/imprint/osa_logo_ok.png" />
      </div>
    </div>
  </div>
</template>

<style>
.flags {
  display: flex;
  flex-direction: column;
  margin: 20px;
  width: calc(100% - 40px);
}

.flags > div {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
}

.flags > div > img {
  margin: 20px 40px 0 0;
  width: auto;
  height: 80px;
}

@media screen and (max-width: 600px) {
  .flags > div > img {
    margin-right: 20px;
    height: 50px;
  }
}
</style>

<script>
import Builder from "../components/Builder.vue";

export default {
  title: "Imprint",
  components: {
    Builder
  },
  props: {
    dataObj: Object
  }
};
</script>
